import { Component, HostListener, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { VisorResponse } from 'src/app/modal/visor/visor-response';
import { FichaService } from 'src/app/service/ficha/ficha.service';
import { DomSanitizer, Title } from '@angular/platform-browser';

@Component({
  selector: 'app-visor',
  templateUrl: './visor.component.html',
  styleUrls: ['./visor.component.scss']
})
export class VisorComponent implements OnInit {

  constructor(private titleService: Title,private route: ActivatedRoute, private fichaService: FichaService, private sanitizer: DomSanitizer) {
    this.titleService.setTitle("VISOR");

   }
  idDocumental: String;
  flagLoading: boolean;
  visorModal: VisorResponse;
  urlDocumental: string;
  pdfSrc = "https://repositoriodigital.bnp.gob.pe/bnp/recursos/2/pdf/carta-de-ricardo-seminario-a-nicolas-de-pierola-6-de-mayo-de-1896.pdf";

  ftitulo:boolean=false;
  fautor:boolean=false;
  ffechPubli:boolean=false;
  ftema:boolean=false;
  fdescripcion:boolean=false;
  ftipo:boolean=false;
  fnota:boolean=false;
  flicencia:boolean=false;
  flagMostrar:boolean=false;
 
  flagImagen:boolean=false;
  botonDowloand="DESCARGAR";
  iconDowloand="fa fa-download"
  @HostListener('contextmenu', ['$event'])
  
  clickDerecho(){
    console.log("aca");
  }
  obtenerDetalleDocumental() {
    this.flagLoading = false;
    this.visorModal = new VisorResponse();
    console.log(this.idDocumental);
    this.fichaService.obtenerDatosVisor(this.idDocumental).subscribe(data => {
      this.visorModal = data;
      console.log(this.visorModal);
      this.urlDocumental = this.visorModal.response.list[0].urlBasic + this.visorModal.response.list[0].directorio + this.visorModal.response.list[0].url + '#toolbar=1&zoom=80';
      if(this.visorModal.response.list[0].tipo=="Video"){
        this.urlDocumental = this.visorModal.response.list[0].url;
        let idYoutube = this.urlDocumental.split("/")[3];
        this.urlDocumental = "https://www.youtube.com/embed/"+ idYoutube;
        this.botonDowloand="REPRODUCIR"
        this.iconDowloand="fas fa-play"
      }
      if(this.visorModal.response.list[0].tipo=="Audio"){
        this.botonDowloand="REPRODUCIR"
        this.iconDowloand="fas fa-play"

      }
      if(this.visorModal.response.list[0].tipo=="Fotografias"){
        this.flagImagen=true;
      }
      if(this.visorModal.response.list[0].flagDownload=="0"){
        this.urlDocumental = this.visorModal.response.list[0].urlBasic + this.visorModal.response.list[0].directorio + this.visorModal.response.list[0].url + '#toolbar=0&zoom=80&navpanes=0';

      }
      
      console.log(data);
      console.log(this.urlDocumental);
      this.obtenerFlagDatos();
      this.flagLoading = true;
    })

  }

  validarContenido(data){
    if(data!="" || data!=null || data!=''){
      this.flagMostrar=true;
    }
    else{
      this.flagMostrar = false;
    }
  }



  obtenerFlagDatos(){
    let perfil = this.visorModal.response.list[0].perfil.toUpperCase();
    if(perfil=="LIBROS"){
      if(this.visorModal.response.list[0].titulo!=''){
      this.ftitulo=true;
      }
      if(this.visorModal.response.list[0].autores.length>0){
        this.fautor=true;
      }
      if(this.visorModal.response.list[0].fechaPublicacion!=''){
      this.ffechPubli=true;
      }
      if(this.visorModal.response.list[0].tema.length>0){
      this.ftema=true;
      }
      if(this.visorModal.response.list[0].descripcion!=''){      
      this.fdescripcion=true;
      }
      if(this.visorModal.response.list[0].tipo!=''){
      this.ftipo=true;
      }
      if(this.visorModal.response.list[0].nota!=''){
      this.fnota=true;
      }
      if(this.visorModal.response.list[0].licencia.length>0){
      this.flicencia=true;
      }
    }
    else if(perfil=="DIARIOS Y REVISTAS"){
      if(this.visorModal.response.list[0].titulo!=''){
        this.ftitulo=true;
        }
        if(this.visorModal.response.list[0].autores.length>0){
          this.fautor=true;
        }
        if(this.visorModal.response.list[0].fechaPublicacion!=''){
        this.ffechPubli=true;
        }
        if(this.visorModal.response.list[0].tema.length>0){
        this.ftema=true;
        }
        if(this.visorModal.response.list[0].descripcion!=''){      
        this.fdescripcion=true;
        }
        if(this.visorModal.response.list[0].tipo!=''){
        this.ftipo=true;
        }
        if(this.visorModal.response.list[0].nota!=''){
        this.fnota=true;
        }
        if(this.visorModal.response.list[0].licencia.length>0){
        this.flicencia=true;
        }
    }
    else if(perfil=="DIARIOS Y REVISTAS"){
      if(this.visorModal.response.list[0].titulo!=''){
        this.ftitulo=true;
        }
        if(this.visorModal.response.list[0].autores.length>0){
          this.fautor=true;
        }
        if(this.visorModal.response.list[0].fechaPublicacion!=''){
        this.ffechPubli=true;
        }
        if(this.visorModal.response.list[0].tema.length>0){
        this.ftema=true;
        }
        if(this.visorModal.response.list[0].descripcion!=''){      
        this.fdescripcion=true;
        }
        if(this.visorModal.response.list[0].tipo!=''){
        this.ftipo=true;
        }
        if(this.visorModal.response.list[0].nota!=''){
        this.fnota=true;
        }
        if(this.visorModal.response.list[0].licencia.length>0){
        this.flicencia=true;
        }
    }
    else if(perfil=="MANUSCRITOS"){
      if(this.visorModal.response.list[0].titulo!=''){
        this.ftitulo=true;
        }
        if(this.visorModal.response.list[0].autores.length>0){
          this.fautor=true;
        }
        if(this.visorModal.response.list[0].fechaPublicacion!=''){
        this.ffechPubli=true;
        }
        if(this.visorModal.response.list[0].tema.length>0){
        this.ftema=true;
        }
        if(this.visorModal.response.list[0].descripcion!=''){      
        this.fdescripcion=true;
        }
        if(this.visorModal.response.list[0].tipo!=''){
        this.ftipo=true;
        }
        if(this.visorModal.response.list[0].nota!=''){
        this.fnota=true;
        }
        if(this.visorModal.response.list[0].licencia.length>0){
        this.flicencia=true;
        }
    }
    else if(perfil=="PARTITURAS"){
      if(this.visorModal.response.list[0].titulo!=''){
        this.ftitulo=true;
        }
        if(this.visorModal.response.list[0].autores.length>0){
          this.fautor=true;
        }
        if(this.visorModal.response.list[0].fechaPublicacion!=''){
        this.ffechPubli=true;
        }
        if(this.visorModal.response.list[0].tema.length>0){
        this.ftema=true;
        }
        if(this.visorModal.response.list[0].descripcion!=''){      
        this.fdescripcion=true;
        }
        if(this.visorModal.response.list[0].tipo!=''){
        this.ftipo=true;
        }
        if(this.visorModal.response.list[0].nota!=''){
        this.fnota=true;
        }
        if(this.visorModal.response.list[0].licencia.length>0){
        this.flicencia=true;
        }
    }
    else if(perfil=="IMÁGENES"){
      if(this.visorModal.response.list[0].titulo!=''){
        this.ftitulo=true;
        }
        if(this.visorModal.response.list[0].autores.length>0){
          this.fautor=true;
        }
        if(this.visorModal.response.list[0].fechaPublicacion!=''){
        this.ffechPubli=true;
        }
        if(this.visorModal.response.list[0].tema.length>0){
        this.ftema=true;
        }
        if(this.visorModal.response.list[0].descripcion!=''){      
        this.fdescripcion=true;
        }
        if(this.visorModal.response.list[0].tipo!=''){
        this.ftipo=true;
        }
        if(this.visorModal.response.list[0].nota!=''){
        this.fnota=true;
        }
        if(this.visorModal.response.list[0].licencia.length>0){
        this.flicencia=true;
        }
    }
    else if(perfil=="MULTIMEDIA"){
      if(this.visorModal.response.list[0].titulo!=''){
        this.ftitulo=true;
        }
        if(this.visorModal.response.list[0].autores.length>0){
          this.fautor=true;
        }
        if(this.visorModal.response.list[0].fechaPublicacion!=''){
        this.ffechPubli=true;
        }
        if(this.visorModal.response.list[0].tema.length>0){
        this.ftema=true;
        }
        if(this.visorModal.response.list[0].descripcion!=''){      
        this.fdescripcion=true;
        }
        if(this.visorModal.response.list[0].tipo!=''){
        this.ftipo=true;
        }
        if(this.visorModal.response.list[0].nota!=''){
        this.fnota=false;
        }
        if(this.visorModal.response.list[0].licencia.length>0){
        this.flicencia=true;
        }
      }
    }


  transform(url) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }
  ngOnInit(): void {

    this.route.paramMap.subscribe((params: ParamMap) => {


      this.idDocumental = params.get('idDocumental');
      this.obtenerDetalleDocumental();


    });
  }




}
